var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"aisea-text-12-400-gray"},[_vm._v(_vm._s(_vm.form.label))]),_c('div',{staticClass:"px-2"},[_vm._v(_vm._s(_vm.inputValue))])])
}
var staticRenderFns = []

export { render, staticRenderFns }